import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from "react-router-dom";
// import { Helmet } from 'react-helmet-async'; // SUPPRIMÉ
import TopNavbarre from '../composants/topnavbarre';
import Footer from '../composants/footer';
import header from '../asset/6.png';
import formation1 from '../asset/formation_1.jpg';
import formation2 from '../asset/formation_2.jpeg';
import formation3 from '../asset/formation_3.jpeg';
import formation4 from '../asset/formation_4.jpeg';

// structure des données organisées par catégories
const formationsParCategorie = [
  {
    categorie: "Nos formations en droit",
    formations: [
      {
        titre: "Bachelor Carrières Juridiques",
        description: "Formation complète pour les métiers du droit avec stages professionnels.",
        image: formation1,
        color: "from-indigo-600 to-indigo-800"
      },
      {
        titre: "Master Droit des Affaires",
        description: "Spécialisation en droit commercial, fiscal et des sociétés.",
        image: formation2,
        color: "from-blue-600 to-blue-800"
      },
      {
        titre: "Master Droit du Travail et RH",
        description: "Expertise en droit social et gestion des ressources humaines.",
        image: formation3,
        color: "from-purple-600 to-purple-800"
      },
      {
        titre: "Master Droit de l'Entreprise et du Numérique",
        description: "Droit appliqué aux nouvelles technologies et à l'économie digitale.",
        image: formation4,
        color: "from-teal-600 to-teal-800"
      },
      {
        titre: "Droit Public",
        description: "Spécialisation en droit administratif et institutions publiques.",
        image: formation1,
        color: "from-green-600 to-green-800"
      },
      {
        titre: "Droit de Santé",
        description: "Expertise en droit médical et réglementation sanitaire.",
        image: formation2,
        color: "from-red-600 to-red-800"
      }
    ]
  },
  {
    categorie: "Nos BTS",
    formations: [
      {
        titre: "BTS SIO (Services Informatiques aux Organisations)",
        description: "Option SLAM (Solutions Logicielles) ou SISR (Infrastructures).",
        image: formation3,
        color: "from-yellow-600 to-yellow-800"
      },
      {
        titre: "BTS MHR (Management en Hôtellerie-Restauration)",
        description: "Formation complète pour managers en secteur hôtelier.",
        image: formation4,
        color: "from-orange-600 to-orange-800"
      },
      {
        titre: "BTS Comptabilité et Gestion",
        description: "Maîtrise des outils comptables et de gestion financière.",
        image: formation1,
        color: "from-pink-600 to-pink-800"
      },
      {
        titre: "BTS MCO (Management Commercial Opérationnel)",
        description: "Techniques de management et développement commercial.",
        image: formation2,
        color: "from-cyan-600 to-cyan-800"
      }
    ]
  },
  {
    categorie: "Nos Bachelors",
    formations: [
      {
        titre: "Bachelor Commerce Marketing Négociation",
        description: "Techniques avancées de vente et stratégies marketing.",
        image: formation3,
        color: "from-indigo-600 to-indigo-800"
      },
      {
        titre: "Bachelor Gestion Financière",
        description: "Expertise en analyse financière et gestion de portefeuille.",
        image: formation4,
        color: "from-blue-600 to-blue-800"
      },
      {
        titre: "Bachelor Logistique et Transport",
        description: "Management des flux et supply chain internationale.",
        image: formation1,
        color: "from-purple-600 to-purple-800"
      },
      {
        titre: "Bachelor Business International",
        description: "Formation trilingue pour le commerce international.",
        image: formation2,
        color: "from-teal-600 to-teal-800"
      },
      {
        titre: "Bachelor Création et Design de Marque",
        description: "Design graphique et stratégie de marque.",
        image: formation3,
        color: "from-green-600 to-green-800"
      },
      {
        titre: "Bachelor Management et Gestion des Entreprises",
        description: "Formation polyvalente en gestion d'entreprise.",
        image: formation4,
        color: "from-red-600 to-red-800"
      },
      {
        titre: "Bachelor Développeur Web",
        description: "Formation intensive en développement fullstack.",
        image: formation1,
        color: "from-yellow-600 to-yellow-800"
      },
      {
        titre: "Bachelor Contrôle de Gestion",
        description: "Outils d'analyse et pilotage de la performance.",
        image: formation2,
        color: "from-orange-600 to-orange-800"
      }
    ]
  },
  {
    categorie: "Nos MBA",
    formations: [
      {
        titre: "MBA SICG",
        description: "Systèmes d'Information et Contrôle de Gestion.",
        image: formation3,
        color: "from-pink-600 to-pink-800"
      },
      {
        titre: "MBA Finance",
        description: "Hautes études financières et gestion de patrimoine.",
        image: formation4,
        color: "from-cyan-600 to-cyan-800"
      },
      {
        titre: "MBA Développeur Full Stack",
        description: "Expertise en développement web et mobile avancé.",
        image: formation1,
        color: "from-indigo-600 to-indigo-800"
      },
      {
        titre: "MBA Expert UX-UI Design",
        description: "Design d'expérience utilisateur et interfaces digitales.",
        image: formation2,
        color: "from-blue-600 to-blue-800"
      },
      {
        titre: "MBA Expert Marketing",
        description: "Stratégies marketing digital et analyse de données.",
        image: formation3,
        color: "from-purple-600 to-purple-800"
      },
      {
        titre: "MBA Management International Business",
        description: "Management interculturel et stratégies globales.",
        image: formation4,
        color: "from-teal-600 to-teal-800"
      },
      {
        titre: "MBA Management Gestion et Finance",
        description: "Double compétence en management et finance.",
        image: formation1,
        color: "from-green-600 to-green-800"
      },
      {
        titre: "MBA Management Commerce et Entreprise",
        description: "Leadership commercial et développement d'entreprise.",
        image: formation2,
        color: "from-red-600 to-red-800"
      }
    ]
  },
  {
    categorie: "Nos Spécialisations",
    formations: [
      {
        titre: "Cybercriminalité et du Numérique",
        description: "Droit appliqué aux nouvelles technologies et cyberdéfense.",
        image: formation3,
        color: "from-yellow-600 to-yellow-800"
      },
      {
        titre: "Droit Pénal des Affaires",
        description: "Contentieux économique et délinquance financière.",
        image: formation4,
        color: "from-orange-600 to-orange-800"
      },
      {
        titre: "Pratique du Contentieux - Droit Privé",
        description: "Techniques de procédure et stratégies contentieuses.",
        image: formation1,
        color: "from-pink-600 to-pink-800"
      },
      {
        titre: "Droit des Affaires et de l'Entreprise",
        description: "Expertise juridique pour les entreprises.",
        image: formation2,
        color: "from-cyan-600 to-cyan-800"
      },
      {
        titre: "Contentieux Public",
        description: "Procédures devant les juridictions administratives.",
        image: formation3,
        color: "from-indigo-600 to-indigo-800"
      },
      {
        titre: "Droit du Sport",
        description: "Réglementation sportive et contrats des sportifs.",
        image: formation4,
        color: "from-blue-600 to-blue-800"
      },
      {
        titre: "Droit de la Responsabilité Médicale",
        description: "Expertise en dommages corporels et erreurs médicales.",
        image: formation1,
        color: "from-purple-600 to-purple-800"
      }
    ]
  },
  {
    categorie: "Nos Masters",
    formations: [
      {
        titre: "Master Européen Management Digital",
        description: "Transformation digitale et stratégies e-business.",
        image: formation2,
        color: "from-teal-600 to-teal-800"
      },
      {
        titre: "Master en Ressources Humaines",
        description: "Gestion stratégique des talents et compétences.",
        image: formation3,
        color: "from-green-600 to-green-800"
      },
      {
        titre: "Master Européen Management et Stratégie",
        description: "Stratégies d'entreprise et management international.",
        image: formation4,
        color: "from-red-600 to-red-800"
      },
      {
        titre: "Master Manager de l'Assurance",
        description: "Expertise en produits et gestion des risques.",
        image: formation1,
        color: "from-yellow-600 to-yellow-800"
      },
      {
        titre: "Master Logistique et Transport",
        description: "Optimisation des flux et supply chain globale.",
        image: formation2,
        color: "from-orange-600 to-orange-800"
      },
      {
        titre: "Master Communication",
        description: "Stratégies de communication corporate et digitale.",
        image: formation3,
        color: "from-pink-600 to-pink-800"
      }
    ]
  }
];

const FormationsSection = () => {
  return (
    <section
      id="formations"
      className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="inline-block bg-blue-400/20 text-blue-300 px-4 py-2 rounded-full text-sm font-medium mb-4">
            Nos Programmes
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Formez-vous pour construire <span className="text-blue-300">votre avenir</span>
          </h2>
          <p className="text-lg text-blue-100 max-w-3xl mx-auto">
            Explorez nos formations professionnelles et académiques dans les domaines les plus demandés.
          </p>
        </motion.div>

        {/* Catégories de formations */}
        <div className="space-y-16">
          {formationsParCategorie.map((categorie, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white/10 backdrop-blur-sm rounded-xl p-6 shadow-lg"
            >
              <h3 className="text-2xl font-bold text-white mb-6 border-b border-blue-400 pb-2">
                {categorie.categorie}
              </h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {categorie.formations.map((formation, fIndex) => (
                  <motion.div
                    key={fIndex}
                    whileHover={{ y: -5 }}
                    className="group relative overflow-hidden rounded-xl h-full min-h-[250px]"
                  >
                    <div className="absolute inset-0">
                      <img 
                        src={formation.image} 
                        alt={formation.titre}
                        className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className={`absolute inset-0 bg-gradient-to-b ${formation.color} opacity-80`}></div>
                    </div>
                    
                    <div className="relative h-full flex flex-col justify-end p-6">
                      <div className="transform group-hover:translate-y-0 transition-transform duration-300">
                        <h4 className="text-xl font-bold text-white mb-2">
                          {formation.titre}
                        </h4>
                        <p className="text-blue-100 opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-sm">
                          {formation.description}
                        </p>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          viewport={{ once: true }}
          className="mt-20 text-center"
        >
          <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl p-8 md:p-10 shadow-xl">
            <div className="max-w-4xl mx-auto">
              <h3 className="text-2xl font-bold text-white mb-4">Prêt à développer vos compétences ?</h3>
              <p className="text-blue-100 mb-6">Nos conseillers pédagogiques sont à votre disposition</p>
              <motion.div 
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="inline-block"
              >
                <Link
                  to="/contact"
                  className="bg-blue-600 hover:bg-blue-700 text-white font-semibold 
                            px-4 py-2 sm:px-6 sm:py-2.5 md:px-8 md:py-3
                            rounded-lg shadow-lg transition-all duration-300 
                            transform hover:-translate-y-1 text-sm sm:text-base mx-auto block text-center"
                >
                  Prendre rendez-vous
                </Link>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

const Formation = () => {
  useEffect(() => {
    document.title = "Formations professionnelles et académiques | LMK Travel";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "Découvrez nos formations en droit, BTS, Bachelor, MBA, spécialisations et masters. Formez-vous dans les domaines les plus demandés avec LMK Travel.");
    } else {
      const meta = document.createElement('meta');
      meta.name = "description";
      meta.content = "Découvrez nos formations en droit, BTS, Bachelor, MBA, spécialisations et masters. Formez-vous dans les domaines les plus demandés avec LMK Travel.";
      document.head.appendChild(meta);
    }
  }, []);

  const handleScroll = (e) => {
    e.preventDefault();
    const nextSection = document.getElementById('content');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-gray-50">
      {/* Helmet supprimé */}
      <section className="relative bg-cover bg-center h-screen flex flex-col">
        {/* Image de fond avec overlay */}
        <div 
          className="absolute inset-0 bg-black/30 bg-blend-darken"
          style={{
            backgroundImage: `url(${header})`,
            backgroundPosition: 'center 30%',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
          }}
        ></div>

        {/* Navbar */}
        <TopNavbarre/>
        
        {/* Contenu principal centré verticalement */}
        <div className="relative z-10 flex-grow flex items-center justify-center text-center">
          <div className="mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl lg:max-w-4xl">
              {/* Titre principal avec animation */}
              <motion.h1 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-2 sm:mb-4"
              >
                Étudiez dans les meilleures <span className="text-blue-400">écoles</span>
              </motion.h1>
              
              {/* Sous-titre */}
              <motion.p 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.8 }}
                className="text-lg sm:text-xl md:text-2xl text-gray-100 mb-6 sm:mb-8 max-w-lg mx-auto"
              >
                Grâce à notre réseau d'écoles partenaires, nous vous offrons un accès privilégié à des formations de qualité dans le monde entier.
              </motion.p>
              
              {/* Bouton */}
              <motion.div 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6, duration: 0.8 }}
                className="flex justify-center"
              >
                <a
                  href="#formations"
                  className="bg-blue-600 hover:bg-blue-700 text-white font-semibold 
                            px-6 py-3 sm:px-8 sm:py-3.5 md:px-10 md:py-4 
                            rounded-lg shadow-lg transition-all duration-300 
                            transform hover:-translate-y-1 text-base sm:text-lg"
                >
                  Découvrir nos formations
                </a>
              </motion.div>
            </div>
          </div>
        </div>
        
        {/* Indicateur de défilement */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
          <motion.a 
            href="#content" 
            className="animate-bounce inline-block"
            onClick={handleScroll}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
            </svg>
          </motion.a>
        </div>
      </section>

      {/* Section des formations */}
      <FormationsSection />
      
      <Footer/>
    </div>
  );
};

export default Formation;